/*requires hei.js */
//
// Basic event and event handling objects
// to do event handling similar to something
// like in C#
//
// Requires: jQuery
//
//  Ben Ramey
//  May 2009

//
// Basic event type
//
HEIJS.Event = function()
{
  this.handlers = {};
};

HEIJS.Event.prototype =
{
  //
  // Properties
  //
  handlers: null,

  //
  // Methods
  //
  AddHandler: function(eventHandler)
  {
    this.handlers[eventHandler.id] = eventHandler;
  },

  RemoveHandler: function(eventHandler)
  {
    delete this.handlers[eventHandler.id];
  },

  Trigger: function(arguments)
  {
	if (arguments && arguments.hasOwnProperty('key')) //pass in a 'key' argument if we explicitly want one handler to run
	{
		var handler = this.handlers[arguments.key];
		
		if (handler)
		{
			if ($.isFunction(handler.f))
			{
				(handler.f).call(handler.c, arguments)
			}
			
			if (handler.oneTime)
			{
				delete this.handlers[arguments.key];
			}
		}
	}
	else
	{
		for (var id in this.handlers)
		{
		  if ($.isFunction(this.handlers[id].f))
		  {
			// calls the event function, in the context that the
			// owner of the event function wants it to be called in.
			// also passes in arguments that event function wants
			if (typeof (this.handlers[id].c) !== "undefined")
			  (this.handlers[id].f).call(this.handlers[id].c, arguments);
		  }

		  if (this.handlers[id].oneTime)
			delete this.handlers[id];
		}
	}
  }
};

//
// Event handler type
//
HEIJS.EventHandlerID = 0;
HEIJS.EventHandler = function(handlerFunction, handlerContext, callOnce)
{
  this.id = HEIJS.EventHandlerID;
  this.f = handlerFunction;
  this.c = handlerContext;
  this.oneTime = callOnce || false;
 
  HEIJS.EventHandlerID++;
};